<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter6">
<h1><a id="page_24"></a><a href="#/003toc#ch6">Shiitake Mushroom Miso Soup</a></h1>
<p class="noindent">Miso soup is not only good for you but also terrific for a warm-up on a cold day. This soup is enriched with bok choy and shiitake mushrooms, making it a hearty vegetable soup to serve anytime.</p>
<p class="noindent">2 tablespoons vegetable oil</p>
<p class="noindent">1 clove garlic, minced</p>
<p class="noindent">1 teaspoon freshly grated ginger</p>
<p class="noindent">8 ounces shiitake mushrooms, stems removed, caps sliced</p>
<p class="noindent">4 small baby bok choy, stem ends removed and chopped into ½-inch pieces (see savvy)</p>
<p class="noindent">¼ cup light miso paste (see savvy)</p>
<p class="noindent">6 cups vegetable or chicken broth</p>
<p class="noindent">2 teaspoons soy sauce</p>
<p class="noindent">6 green onions, finely chopped using the white and tender green parts</p>
<p class="noindent">1 pound firm tofu, drained and cut into</p>
<p class="noindent">½-inch cubes</p>
<p class="noindent">heat the oil in a medium skillet over medium-high heat.</p>
<p class="noindent">add the garlic and ginger and sauté, about 1 minute until fragrant. Add the mushrooms and toss to combine.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5-quart slow cooker and add the bok choy. Stir in the miso paste, broth, and soy sauce.</p>
<p class="noindent">cover the slow cooker and cook on high for 2½ to 3 hours.</p>
<p class="noindent">remove the cover and stir in the green onions and tofu.</p>
<p class="noindent">serve the soup from the slow cooker.</p>
<p class="noindent">Serves 6–8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/>bok choy savvy</p>
<p class="noindent">If bok choy is very expensive, as it can be, chopped napa cabbage may be substituted. You should have about 2 cups.</p>
<p class="noindent"><strong>miso savvy</strong></p>
<p class="noindent">Miso is found in the Asian section of your supermarket.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012-chapter6.vue?5a28c858